import { render } from "./StrategiesView.vue?vue&type=template&id=063443b8&scoped=true"
import script from "./StrategiesView.vue?vue&type=script&lang=js"
export * from "./StrategiesView.vue?vue&type=script&lang=js"

import "./StrategiesView.vue?vue&type=style&index=0&id=063443b8&lang=scss&scoped=true"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063443b8"]])

export default __exports__